
import { isValueEmptyProto } from "../utils/utils.js"
import userRoles from "../utils/applicationRoles.js"

export const currentUserName1 = state => state.login.userName
export const currentUserID = state => state.login.userID

export const searchText = state => state.app.searchText
export const filterDates = state => state.app.filterDates

//global
export const showBlockUI = state =>  state.app.showBlockUI
export const loadingImage = state => state.app.loadingImage
export const loadingMessage = state => state.app.loadingMessage
export const states = state => state.app.states
export const makes = state => state.app.makes
export const fuelTypes = state => state.app.fuelTypes
export const models = state => state.app.models
export const parts = state => state.app.parts
export const componentTypes = state => state.app.componentTypes
export const roles = state => userRoles
export const enhancements = state => state.app.enhancements
export const statusList = state => state.app.status
export const selectedStates = state => state.app.selectedStates
export const acceptedDates = state => state.app.acceptedDates
export const lastNavigation = state => state.app.lastNavigation
export const useMitel = state => state.app.useMitel
export const mitelIsLoggedIn = state => state.app.mitelIsLoggedIn
export const useLiveVox = state => state.app.useLiveVox
export const livevoxIsLoggedIn = state => state.app.livevoxIsLoggedIn
export const useVerint = state => state.app.useVerint
export const verintIsLoggedIn = state => state.app.verintIsLoggedIn
export const enableClipboardCopyOnOutboundDial = state => state.app.enableClipboardCopyOnOutboundDial



////wizard
export const steps = state => state.wizard.steps
export const currentstep = state => state.wizard.currentstep
export const selectedCallCodeWizard = state => state.wizard.selected_call_code_wizard

//wizard steps -- Customer information
export const wizardData = state => state.wizard.wizardData
export const carModelList = state => state.wizard.car_model_list

//quote list
export const quote_list = state => state.wizard.quote_list
export const web_quote_queue = state => state.wizard.web_quote_queue
export const quote_list_admin = state => state.admin_quotes.quote_list_admin
export const selectedAdminQuote = state => state.admin_quotes.selectedAdminQuote

//call codes
export const callCodes = state => state.callcodes.call_codes
export const callCodesTypes = state => state.callcodes.call_codes_types
export const customerCallCodes = state => state.callcodes.customer_call_codes

//users
export const users = state => state.users.users
export const userTypes = state => state.users.user_types
export const permissions = state => state.users.permissions
export const selectedUser = state => state.users.selected_user

//notifications
export const todo_list = state => state.notifications.todos.filter((todo) => {
	return todo.completed === false
}).map((n) => {return n})

export const notificationsList = state => state.notifications.notification_list.filter((notification) => {
	return notification.acknowledge === false && notification.status === 'Sent'
}).map((n) => {return n})

export const notificationsListAdmin = state => state.notifications.notification_list

export const selectedNotification = state => state.notifications.selected_notification
export const selectedNotificationAdmin = state => state.notifications.selected_notification_admin

export const restrictions = state => state.restrictions.restrictions.sort((a,b) => {
	if (a.id < b.id) { return -1 }
	if (a.id > b.id) { return 1 }
	return 0;
})
export const selectedRestriction = state => state.restrictions.selected_restriction

export const resolutions = state => state.dispositions.resolutions
export const activeDispositions = state => state.dispositions.activeDispositions
export const dispositionTypes = state => state.dispositions.dispositionTypes
export const selectedResolution = state => state.dispositions.selectedResolution
export const activefollowupResultTypes = state => state.dispositions.activefollowupResultTypes

//statelaws
export const selectedStateLaws = state => state.statelaws.selected_statelaws
export const selectedState = state => state.statelaws.selected_state

//thirdParty
// this actually returns ALL third party partners, no as the name suggest only "active" third party partners
export const activeThirdPartyPartners = state => state.thirdparty.activeThirdPartyPartners
export const inactiveThirdPartyPartners = state => state.thirdparty.allThirdPartyPartners.filter(item => !item.isActive);

//logs
export const logs = state => state.logger.logs



// WEBPACK FOOTER //
// ./src/store/getters.js